import { render, staticRenderFns } from "./my-class-schedule.vue?vue&type=template&id=85d82712&scoped=true"
import script from "./my-class-schedule.vue?vue&type=script&lang=js"
export * from "./my-class-schedule.vue?vue&type=script&lang=js"
import style0 from "./my-class-schedule.vue?vue&type=style&index=0&id=85d82712&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85d82712",
  null
  
)

export default component.exports